import React, { Component } from "react";
import { Helmet } from "react-helmet";
import fs from "fs";

//images
import Story1Img from "../../Assets/Images/ourMinistries/Publications/Stories/0.jpg";
import Story2Img from "../../Assets/Images/ourMinistries/Publications/Stories/1.jpg";

//story
import Story1Txt from "../../Assets/Texts/ourMinistries/Publications/Stories/0.js";
import Story2Txt from "../../Assets/Texts/ourMinistries/Publications/Stories/1.js";

const Stories = {
  0: { title: "灾难中的故事", image: Story1Img, text: Story1Txt },
  1: { title: "憶水災 訴心聲 Hulu Langat災民有話說", image: Story2Img, text: Story2Txt },
};
class Story extends Component {
  constructor(props) {
    super(props);
    this.state = { imageSize: { height: 0, width: 0 }, parentSize: { height: 0, width: 0 } };
    this.onImageLoad = this.onImageLoad.bind(this);
  }
  onImageLoad = (image) => {
    const img = new Image();
    img.src = image;
    this.setState({
      imageSize: {
        height: img.height,
        width: img.width,
      },
      parentSize: {
        height: document.getElementsByClassName("story-image")[0].offsetHeight,
        width: document.getElementsByClassName("story-image")[0].offsetWidth,
      },
    });
  };
  render() {
    return (
      <div className="story">
        <Helmet>
          <title>CAC MCRD {Stories[this.props.story].title}</title>
          <meta property="og:url" content={"https://cacmcrd.netlify.app/Ministries/Stories/" + this.props.story} />
          <meta property="og:type" content={"organization infomation"} />
          <meta property="og:title" content={"CAC MCRD " + Stories[this.props.story].title} />
          <meta property="og:description" content={Stories[this.props.story].text.substring(0, 100)} />
          <meta property="og:image" content={Stories[this.props.story].image} />
        </Helmet>
        <div className="title">
          <label>{Stories[this.props.story].title}</label>
        </div>
        {Stories[this.props.story].image != null ? (
          <div className="story-image">
            <img
              onLoad={() => this.onImageLoad(Stories[this.props.story].image)}
              style={{
                width: this.state.parentSize.width,
                height: (this.state.parentSize.width / this.state.imageSize.width) * this.state.imageSize.height,
              }}
              src={Stories[this.props.story].image}
              alt={"story image not found"}
            />
          </div>
        ) : null}
        <div className="content">
          <p>{Stories[this.props.story].text}</p>
        </div>
      </div>
    );
  }
  readStory = (e) => {
    console.log("isFired!:" + e);
    /*var reader = new FileReader()
    reader.readAsText(e);
    reader.onload = function(){
        console.log("someResult:" + reader.error);
        return reader.result;
    }
    reader.onerror = function(){
        console.log("someerror:" + reader.error);
    }*/
    fs.readFile(e, (data) => {
      return data;
    });
  };
}
export default Story;
